module.exports = __webpack_public_path__ + "static/img/home6.a11702b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/home6.jpg
// module id = 5mRS
// module chunks = 1